import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import $ from "jquery";

const logo = require("./../assets/img/logo-sidebar.svg").default;

const Sidebar = () => {
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [storedUserData, setStoredUserData] = useState();

  useEffect(() => {
    $(".mobileBtn").click(() => {
      $(".sideBar").toggleClass("active");
    });
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setStoredUserData(storedUserData);
  }, []);

  return (
    <div className="sideBarDiv">
      <div className="mainLogo">
        <img src={logo} alt="image" />
      </div>

      <div className="navDiv">
        <ul>
          <li>
            <NavLink to="" className="mainLink">
              Waiver Bill
            </NavLink>
            <ul className={`submenu ${sidebarVisible ? "active" : ""}`}>
              <li>
                <NavLink to="/upload-file" activeClassName="active">
                  Upload File
                </NavLink>
              </li>
              <li>
                <NavLink to="/create-files" activeClassName="active">
                  Create Files
                </NavLink>
              </li>
              <li>
                <NavLink to="/blank-form" activeClassName="active">
                  Blank Form
                </NavLink>
              </li>
              <li>
                <NavLink to="/view-forms" activeClassName="active">
                  View Forms
                </NavLink>
              </li>
              <li>
                <NavLink to="/trash" activeClassName="active">
                  Trash
                </NavLink>
              </li>
              {/* <li>
                <NavLink to="/view-signed-forms" activeClassName="active">
                  View signed Forms
                </NavLink>
              </li> */}
              {/* {Number(storedUserData?.role_id) !== 1 ? ( */}
              {/* ) : null} */}
              {Number(storedUserData?.role_id) === 1 ? (
                <li>
                  <NavLink to="/users" activeClassName="active">
                    Users
                  </NavLink>
                </li>
              ) : null}
              {Number(storedUserData?.role_id) === 1 ? (
                <li>
                  <NavLink to="/edit-term" activeClassName="active">
                    Terms & Conditions
                  </NavLink>
                </li>
              ) : null}
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
